(function () {
  'use strict';

  var cta = document.querySelector('[data-cdi-driven-cta]');
  if (!cta || cta.dataset.cdiInit) return;
  cta.dataset.cdiInit = 'true';

  var state = {
    basePrice: Number(cta.dataset.basePrice) || 0,
    variantId: cta.dataset.variantId || '',
    variantTitle: cta.dataset.variantTitle || '',
    sku: cta.dataset.sku || '',
    productTitle: cta.dataset.productTitle || '',
    selected: {}
  };

  function fmt(cents) {
    if (typeof window.cdiFormatMoney === 'function') {
      return window.cdiFormatMoney(cents, window.cdiMoneyFormat);
    }
    return '$' + ((Number(cents) || 0) / 100).toLocaleString('en-AU', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  function tpl(str, map) {
    return String(str || '').replace(/\[(\w+)\]/g, function (m, key) {
      return map[key] != null ? map[key] : m;
    });
  }

  function addonTotal() {
    return Object.keys(state.selected).reduce(function (sum, id) {
      var item = state.selected[id];
      return sum + item.price * (item.qty || 1);
    }, 0);
  }

  function emit() {
    document.dispatchEvent(new CustomEvent('cdi:driven:change'));
    if (typeof publish === 'function') {
      var total = addonTotal();
      publish('cdi:addonSync', { addonTotal: total, hasAddons: total > 0 });
    }
  }

  var stockRequests = {};

  function fetchStock(sku) {
    if (!sku || !window.CDI_PORTAL_URL) return Promise.resolve(null);
    if (stockRequests[sku]) return stockRequests[sku];
    var controller = new AbortController();
    var timer = setTimeout(function () {
      controller.abort();
    }, 8000);
    stockRequests[sku] = fetch(
      window.CDI_PORTAL_URL + '/api/internal/inventory?sku=' + encodeURIComponent(sku),
      { method: 'GET', cache: 'default', signal: controller.signal }
    )
      .then(function (res) {
        clearTimeout(timer);
        return res.ok ? res.json() : null;
      })
      .then(function (data) {
        if (!data || (typeof data.brisbane !== 'string' && typeof data.sydney !== 'string')) return null;
        return data;
      })
      .catch(function () {
        clearTimeout(timer);
        return null;
      });
    return stockRequests[sku];
  }

  function renderStock(root, tile) {
    var el = tile.querySelector('[data-cdi-driven-stock]');
    if (!el) return;
    var labels = root.dataset;
    var policy = tile.dataset.policy;

    function set(text, tone) {
      el.textContent = text;
      el.className = 'cdi-driven-addon__stock is-' + tone;
    }

    function notInStock() {
      if (policy === 'continue') set(labels.stockBackorder, 'wait');
      else set(labels.stockQuote, 'neutral');
    }

    fetchStock(tile.dataset.sku).then(function (data) {
      if (!tile.isConnected) return;
      if (!data) {
        if (tile.dataset.managed === 'true' && Number(tile.dataset.qty) > 0) set(labels.stockIn, 'ok');
        else notInStock();
        return;
      }
      var bne = data.brisbane === 'in_stock';
      var syd = data.sydney === 'in_stock';
      if (bne && syd) set(labels.stockInBoth, 'ok');
      else if (bne) set(labels.stockInBrisbane, 'ok');
      else if (syd) set(labels.stockInSydney, 'ok');
      else notInStock();
    });
  }

  function paintAddons(root) {
    var labels = root.dataset;
    var tiles = root.querySelectorAll('.cdi-driven-addons__grid [data-cdi-driven-addon]');
    var rail = tiles.length >= 4;
    var count = 0;
    tiles.forEach(function (tile) {
      var id = tile.dataset.productId;
      var unavailable = tile.classList.contains('cdi-driven-addon--unavailable');
      if (unavailable && state.selected[id]) delete state.selected[id];
      var on = !!state.selected[id];
      if (on) {
        state.selected[id].price = Number(tile.dataset.price) || 0;
        state.selected[id].title = tile.dataset.title;
        state.selected[id].sku = tile.dataset.sku || '';
        state.selected[id].image = tile.dataset.image || '';
        state.selected[id].variantId = tile.dataset.variantId || '';
        state.selected[id].qty = 1;
        count += 1;
      }
      tile.classList.toggle('is-selected', on);
      if (tile.hasAttribute('data-cdi-driven-addon-toggle')) {
        tile.setAttribute('aria-pressed', on ? 'true' : 'false');
      }
    });
    root.querySelectorAll('[data-cdi-driven-addon-group]').forEach(function (group) {
      var units = 0;
      group.querySelectorAll('[data-cdi-driven-addon]').forEach(function (row) {
        var id = row.dataset.productId;
        var unavailable = row.classList.contains('cdi-driven-addon-row--unavailable');
        if (unavailable && state.selected[id]) delete state.selected[id];
        var item = state.selected[id];
        var max = Math.max(1, Number(row.dataset.maxQty) || 1);
        if (item) {
          item.price = Number(row.dataset.price) || 0;
          item.title = row.dataset.title;
          item.sku = row.dataset.sku || '';
          item.image = row.dataset.image || '';
          item.variantId = row.dataset.variantId || '';
          item.qty = Math.min(item.qty || 1, max);
          units += item.qty;
        }
        var qty = item ? item.qty : 0;
        row.classList.toggle('is-selected', qty > 0);
        var valueEl = row.querySelector('[data-cdi-driven-qty-value]');
        if (valueEl) valueEl.textContent = qty;
        var less = row.querySelector('[data-cdi-driven-qty="-1"]');
        var more = row.querySelector('[data-cdi-driven-qty="1"]');
        if (less) less.disabled = qty <= 0;
        if (more) more.disabled = qty >= max;
      });
      var groupCount = group.querySelector('[data-cdi-driven-group-count]');
      if (groupCount) groupCount.textContent = units ? tpl(labels.labelCount, { count: units }) : labels.labelNone;
    });
    var countEl = root.querySelector('[data-cdi-driven-addons-count]');
    if (countEl) {
      if (!count) countEl.textContent = labels.labelNone;
      else if (rail) countEl.textContent = tpl(labels.labelCountOf, { count: count, total: tiles.length });
      else countEl.textContent = tpl(labels.labelCount, { count: count });
    }
    root.classList.toggle('is-rail', rail);
    syncRail(root);
  }

  function syncRail(root) {
    var viewport = root.querySelector('[data-cdi-driven-addons-viewport]');
    var prev = root.querySelector('[data-cdi-driven-addons-prev]');
    var next = root.querySelector('[data-cdi-driven-addons-next]');
    if (!viewport) return;
    var rail = root.classList.contains('is-rail');
    var max = viewport.scrollWidth - viewport.clientWidth;
    var atStart = !rail || viewport.scrollLeft <= 2;
    var atEnd = !rail || viewport.scrollLeft >= max - 2;
    viewport.classList.toggle('has-more-start', !atStart);
    viewport.classList.toggle('has-more-end', !atEnd);
    if (prev) prev.disabled = atStart;
    if (next) next.disabled = atEnd;
  }

  function scrollRail(root, dir) {
    var viewport = root.querySelector('[data-cdi-driven-addons-viewport]');
    var tile = root.querySelector('.cdi-driven-addons__grid [data-cdi-driven-addon]');
    if (!viewport || !tile) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    viewport.scrollBy({ left: dir * (tile.getBoundingClientRect().width + 8), behavior: reduce ? 'auto' : 'smooth' });
  }

  function refreshStock(root) {
    root.querySelectorAll('[data-cdi-driven-addon]').forEach(function (tile) {
      renderStock(root, tile);
    });
  }

  function initAddons(root) {
    if (root.dataset.cdiInit) return;
    root.dataset.cdiInit = 'true';
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-cdi-driven-addons-prev]')) return scrollRail(root, -1);
      if (e.target.closest('[data-cdi-driven-addons-next]')) return scrollRail(root, 1);
      var step = e.target.closest('[data-cdi-driven-qty]');
      if (step && root.contains(step)) {
        var row = step.closest('[data-cdi-driven-addon]');
        var rowId = row.dataset.productId;
        var max = Math.max(1, Number(row.dataset.maxQty) || 1);
        var current = state.selected[rowId] ? state.selected[rowId].qty || 1 : 0;
        var next = Math.min(max, Math.max(0, current + Number(step.dataset.cdiDrivenQty)));
        if (next === current) return;
        if (next === 0) delete state.selected[rowId];
        else state.selected[rowId] = { title: row.dataset.title, price: Number(row.dataset.price) || 0, qty: next, sku: row.dataset.sku || '', variantId: row.dataset.variantId || '', image: row.dataset.image || '' };
        paintAddons(root);
        emit();
        return;
      }
      var tile = e.target.closest('[data-cdi-driven-addon-toggle]');
      if (!tile || !root.contains(tile)) return;
      var id = tile.dataset.productId;
      if (state.selected[id]) delete state.selected[id];
      else state.selected[id] = { title: tile.dataset.title, price: Number(tile.dataset.price) || 0, qty: 1, sku: tile.dataset.sku || '', variantId: tile.dataset.variantId || '', image: tile.dataset.image || '' };
      paintAddons(root);
      emit();
    });
    var viewport = root.querySelector('[data-cdi-driven-addons-viewport]');
    if (viewport) {
      viewport.addEventListener('scroll', function () {
        syncRail(root);
      }, { passive: true });
      if ('ResizeObserver' in window) {
        new ResizeObserver(function () {
          syncRail(root);
        }).observe(viewport);
      }
    }
    paintAddons(root);
    refreshStock(root);
  }

  function onVariantChange(event) {
    var data = event && event.data;
    if (!data) return;
    var variant = data.variant;
    if (variant) {
      state.basePrice = Number(variant.price) || 0;
      state.variantId = String(variant.id);
      state.variantTitle = variant.title || '';
      state.sku = variant.sku || '';
      cta.dataset.variantId = state.variantId;
    }
    var root = document.getElementById('DrivenAddons-' + data.sectionId);
    var fresh = data.html && data.html.getElementById('DrivenAddons-' + data.sectionId);
    if (root && fresh) {
      var grid = root.querySelector('.cdi-driven-addons__grid');
      var freshGrid = fresh.querySelector('.cdi-driven-addons__grid');
      if (grid && freshGrid) grid.innerHTML = freshGrid.innerHTML;
      root.querySelectorAll('[data-cdi-driven-addon-group]').forEach(function (group) {
        var list = group.querySelector('[data-cdi-driven-group-list]');
        var freshGroup = fresh.querySelector('[data-cdi-driven-addon-group="' + group.dataset.cdiDrivenAddonGroup + '"]');
        var freshList = freshGroup && freshGroup.querySelector('[data-cdi-driven-group-list]');
        if (list && freshList) list.innerHTML = freshList.innerHTML;
      });
      paintAddons(root);
      refreshStock(root);
    }
    emit();
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, onVariantChange);
  }

  function quoteUrl() {
    var base = cta.dataset.enquiryUrl || cta.dataset.fallbackUrl;
    var sep = base.indexOf('?') === -1 ? '?' : '&';
    return base + sep + 'product=' + encodeURIComponent(cta.dataset.productHandle) +
      '&variant=' + encodeURIComponent(state.variantId || cta.dataset.variantId);
  }

  function initQuote(root) {
    if (root.dataset.cdiInit) return null;
    root.dataset.cdiInit = 'true';
    var wrapper = root.closest('.shopify-section') || root;
    if (wrapper.parentElement !== document.body) document.body.appendChild(wrapper);

    var labels = root.dataset;
    var dialog = root.querySelector('[data-cdi-driven-quote-dialog]');
    var title = root.querySelector('[data-cdi-driven-quote-title]');
    var form = root.querySelector('[data-cdi-driven-quote-form]');
    var body = root.querySelector('[data-cdi-driven-quote-body]');
    var scroller = root.querySelector('[data-cdi-driven-quote-scroll]');
    var submitBtn = root.querySelector('[data-cdi-driven-quote-submit]');
    var formError = root.querySelector('[data-cdi-driven-quote-form-error]');
    var otherField = root.querySelector('[data-cdi-driven-quote-other]');
    var includes = root.querySelector('[data-cdi-driven-quote-includes]');
    var fields = form.elements;
    var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    var variants = {};
    var opener = null;
    var sending = false;
    var touched = false;

    try {
      variants = JSON.parse(root.querySelector('[data-cdi-driven-quote-variants]').textContent);
    } catch (err) {
      variants = {};
    }

    function value(name) {
      var el = fields.namedItem(name);
      return el ? String(el.value || '').trim() : '';
    }

    function first(name) {
      var el = fields.namedItem(name);
      el = el && !el.tagName && el.length ? el[0] : el;
      var sx = el && el.closest('cdi-selectx');
      return (sx && sx.querySelector('.cdi-selectx__trigger')) || el;
    }

    function node(tag, className, text) {
      var el = document.createElement(tag);
      if (className) el.className = className;
      if (text != null) el.textContent = text;
      return el;
    }

    function renderSummary() {
      var info = variants[state.variantId] || {};
      root.querySelector('[data-cdi-driven-quote-finish]').textContent = state.variantTitle;
      var swatch = root.querySelector('[data-cdi-driven-quote-swatch]');
      swatch.style.backgroundImage = '';
      swatch.style.backgroundColor = '';
      if (info.swatch) {
        if (info.swatch.indexOf('url(') === 0) swatch.style.backgroundImage = info.swatch;
        else swatch.style.backgroundColor = info.swatch;
      }
      swatch.classList.toggle('is-visible', !!info.swatch);
      root.querySelector('[data-cdi-driven-quote-base]').textContent = fmt(state.basePrice);

      var list = root.querySelector('[data-cdi-driven-quote-lines]');
      list.textContent = '';
      Object.keys(state.selected).forEach(function (id) {
        var item = state.selected[id];
        var qty = item.qty || 1;
        var li = node('li', 'cdi-driven-quote__line');
        var thumb = node('span', 'cdi-driven-quote__line-thumb');
        if (item.image) {
          var img = document.createElement('img');
          img.src = item.image;
          img.alt = '';
          img.width = 32;
          img.height = 32;
          thumb.appendChild(img);
        }
        var name = node('span', 'cdi-driven-quote__line-title', item.title);
        if (qty > 1) name.appendChild(node('span', 'cdi-driven-quote__line-qty', '× ' + qty));
        li.appendChild(thumb);
        li.appendChild(name);
        li.appendChild(node('span', 'cdi-driven-quote__line-amount', fmt(item.price * qty)));
        list.appendChild(li);
      });

      var total = fmt(state.basePrice + addonTotal());
      root.querySelector('[data-cdi-driven-quote-total]').textContent = total;
      root.querySelector('[data-cdi-driven-quote-foot-total]').textContent = total;

      var media = root.querySelector('.cdi-driven-quote__media img');
      if (media && info.image && media.dataset.variantId !== state.variantId) {
        media.removeAttribute('srcset');
        media.removeAttribute('sizes');
        media.src = info.image;
        media.dataset.variantId = state.variantId;
      }
    }

    function syncSeg(seg) {
      var inputs = seg.querySelectorAll('input[type="radio"]');
      var index = -1;
      inputs.forEach(function (input, i) {
        if (input.checked) index = i;
      });
      if (index < 0) {
        seg.classList.remove('is-set');
        return;
      }
      if (!seg.classList.contains('is-set')) {
        seg.classList.add('is-instant');
        seg.style.setProperty('--dq-seg-index', index);
        void seg.offsetWidth;
        seg.classList.add('is-set');
        requestAnimationFrame(function () {
          seg.classList.remove('is-instant');
        });
        return;
      }
      seg.style.setProperty('--dq-seg-index', index);
    }

    function syncEmpty(select) {
      var sx = select && select.closest('cdi-selectx');
      if (sx) sx.classList.toggle('is-empty', !select.value);
    }

    function syncFades() {
      var max = body.scrollHeight - body.clientHeight;
      var top = body.scrollTop > 2;
      var bottom = body.scrollTop < max - 2;
      if (scroller.classList.contains('has-more-top') !== top) scroller.classList.toggle('has-more-top', top);
      if (scroller.classList.contains('has-more-bottom') !== bottom) scroller.classList.toggle('has-more-bottom', bottom);
    }

    function revealList(sx) {
      var list = sx.querySelector('.cdi-selectx__dropdown');
      if (!list) return;
      var selected = list.querySelector('.cdi-selectx__option--selected');
      if (selected && selected.dataset.value) {
        list.scrollTop = Math.max(0, selected.offsetTop - (list.clientHeight - selected.offsetHeight) / 2);
      }
      var gap = list.getBoundingClientRect().bottom - (body.getBoundingClientRect().bottom - 40);
      if (gap > 0) body.scrollBy({ top: gap, behavior: reduceMotion() ? 'auto' : 'smooth' });
    }

    function reduceMotion() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function syncOther() {
      var on = value('vehicle') === 'Other';
      otherField.classList.toggle('is-visible', on);
      fields.namedItem('vehicle_other').required = on;
      return on;
    }

    function syncIncludes() {
      includes.classList.toggle('is-visible', value('installation') === 'Supplied & fitted');
    }

    function setError(el, message) {
      var field = el && el.closest('[data-cdi-driven-quote-field]');
      if (!field) return;
      field.classList.toggle('is-invalid', !!message);
      var text = field.querySelector('[data-cdi-driven-quote-error]');
      if (text) text.textContent = message || '';
      field.querySelectorAll('input, select, .cdi-selectx__trigger').forEach(function (input) {
        if (message) input.setAttribute('aria-invalid', 'true');
        else input.removeAttribute('aria-invalid');
      });
    }

    function showFormError(message) {
      formError.textContent = message || '';
      formError.classList.toggle('is-visible', !!message);
    }

    function validate() {
      var email = value('email');
      var checks = [
        ['name', value('name') ? '' : labels.labelRequired],
        ['email', !email ? labels.labelRequired : EMAIL.test(email) ? '' : labels.labelEmail],
        ['state', value('state') ? '' : labels.labelChoose],
        ['vehicle', value('vehicle') ? '' : labels.labelChoose],
        ['vehicle_other', value('vehicle') !== 'Other' || value('vehicle_other') ? '' : labels.labelRequired],
        ['vehicle_year', value('vehicle_year') ? '' : labels.labelChoose],
        ['cab_type', value('cab_type') ? '' : labels.labelChoose],
        ['installation', value('installation') ? '' : labels.labelChoose]
      ];
      var bad = null;
      checks.forEach(function (check) {
        var el = first(check[0]);
        setError(el, check[1]);
        if (check[1] && !bad) bad = el;
      });
      if (!bad) showFormError('');
      return bad;
    }

    function payload() {
      var vehicle = value('vehicle');
      var fitted = value('installation') === 'Supplied & fitted';
      return {
        enquiry_type: 'pkg_quote',
        version: 1,
        product_handle: cta.dataset.productHandle,
        product_title: state.productTitle,
        product_url: labels.productUrl + '?variant=' + encodeURIComponent(state.variantId),
        variant_id: state.variantId,
        finish: state.variantTitle,
        sku: state.sku,
        base_price: state.basePrice,
        addons: Object.keys(state.selected).map(function (id) {
          var item = state.selected[id];
          return {
            title: item.title,
            sku: item.sku || '',
            variant_id: item.variantId || '',
            qty: item.qty || 1,
            unit_price: item.price
          };
        }),
        estimated_total: state.basePrice + addonTotal(),
        name: value('name'),
        email: value('email'),
        phone: value('phone'),
        state: value('state'),
        vehicle: vehicle,
        vehicle_other: vehicle === 'Other' ? value('vehicle_other') : '',
        vehicle_year: value('vehicle_year'),
        vehicle_variant: value('vehicle_variant'),
        cab_type: value('cab_type'),
        installation: value('installation'),
        install_includes: fitted
          ? Array.prototype.map.call(form.querySelectorAll('input[name="install_includes"]:checked'), function (box) {
              return box.value;
            })
          : [],
        notes: value('notes'),
        source: 'product_page',
        submitted_at: new Date().toISOString()
      };
    }

    function trackLead(data) {
      var analytics = window.Shopify && window.Shopify.analytics;
      if (!analytics || typeof analytics.publish !== 'function') return;
      analytics.publish('cdi:generate_lead', {
        form_type: 'pkg_quote',
        form_name: 'Package Enquiry – Product Page',
        product_type: 'Canopy Package',
        lead_type: 'package_enquiry',
        package_handle: data.product_handle,
        package_name: data.product_title,
        finish: data.finish,
        addon_count: data.addons.length,
        vehicle_model: data.vehicle === 'Other' ? data.vehicle_other : data.vehicle,
        vehicle_year: data.vehicle_year,
        cab_type: data.cab_type,
        installation: data.installation,
        state: data.state
      });
    }

    function showSent(data) {
      var firstName = data.name.split(/\s+/)[0];
      root.querySelector('[data-cdi-driven-quote-thanks]').textContent = firstName
        ? tpl(labels.labelThanks, { name: firstName })
        : labels.labelThanksPlain;
      var holder = root.querySelector('[data-cdi-driven-quote-sent-summary]');
      var copy = root.querySelector('[data-cdi-driven-quote-summary]').cloneNode(true);
      [copy].concat(Array.prototype.slice.call(copy.querySelectorAll('*'))).forEach(function (node) {
        Array.prototype.slice.call(node.attributes).forEach(function (attr) {
          if (attr.name.indexOf('data-cdi-driven-quote') === 0) node.removeAttribute(attr.name);
        });
      });
      holder.textContent = '';
      holder.appendChild(copy);
      root.classList.add('is-sent');
      body.scrollTop = 0;
      syncFades();
      title.focus({ preventScroll: true });
      trackLead(data);
    }

    function setBusy(on) {
      sending = on;
      submitBtn.disabled = on;
      submitBtn.setAttribute('aria-busy', on ? 'true' : 'false');
      submitBtn.textContent = on ? labels.labelSending : labels.labelSubmit;
    }

    function focusables() {
      return Array.prototype.filter.call(
        dialog.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'),
        function (el) {
          return !el.disabled && el.getClientRects().length > 0;
        }
      );
    }

    function open(trigger) {
      opener = trigger || document.activeElement;
      document.dispatchEvent(new CustomEvent('cdi:driven:quote-open'));
      root.classList.remove('is-sent');
      showFormError('');
      renderSummary();
      root.classList.add('is-open');
      if (window.CdiScrollLock) window.CdiScrollLock.lock('driven-quote');
      body.scrollTop = 0;
      syncFades();
      title.focus({ preventScroll: true });
    }

    function close() {
      if (!root.classList.contains('is-open')) return;
      var sx = root.querySelector('cdi-selectx[open]');
      if (sx && typeof sx._close === 'function') sx._close();
      root.classList.remove('is-open');
      if (window.CdiScrollLock) window.CdiScrollLock.unlock('driven-quote');
      if (opener && opener.isConnected && typeof opener.focus === 'function') opener.focus();
    }

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-cdi-driven-quote-close]')) close();
    });

    dialog.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var list = focusables();
      if (!list.length) return;
      var start = list[0];
      var end = list[list.length - 1];
      var active = document.activeElement;
      if (e.shiftKey && (active === start || active === dialog || active === title)) {
        e.preventDefault();
        end.focus();
      } else if (!e.shiftKey && active === end) {
        e.preventDefault();
        start.focus();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !root.classList.contains('is-open')) return;
      var sx = root.querySelector('cdi-selectx[open]');
      if (sx) {
        if (!sx.contains(document.activeElement) && typeof sx._close === 'function') {
          sx._close();
          e.preventDefault();
        }
        return;
      }
      close();
    }, true);

    form.addEventListener('change', function (e) {
      syncEmpty(e.target);
      var seg = e.target.closest('[data-cdi-driven-quote-seg]');
      if (seg) syncSeg(seg);
      if (e.target.name === 'vehicle' && syncOther()) {
        setTimeout(function () {
          fields.namedItem('vehicle_other').focus();
        }, 0);
      }
      if (e.target.name === 'installation') syncIncludes();
      if (touched) validate();
      syncFades();
    });

    root.querySelectorAll('[data-cdi-driven-quote-sx]').forEach(function (sx) {
      new MutationObserver(function () {
        if (sx.hasAttribute('open')) revealList(sx);
      }).observe(sx, { attributes: true, attributeFilter: ['open'] });
    });

    body.addEventListener('scroll', syncFades, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(syncFades).observe(body);

    form.addEventListener('input', function () {
      if (touched) validate();
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (sending) return;
      touched = true;
      var bad = validate();
      if (bad) {
        showFormError(labels.labelCheck);
        bad.focus();
        return;
      }
      var data = payload();
      var controller = typeof AbortController === 'function' ? new AbortController() : null;
      var timer = setTimeout(function () {
        if (controller) controller.abort();
      }, 20000);
      setBusy(true);
      fetch(labels.endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
        signal: controller ? controller.signal : undefined
      })
        .then(function (res) {
          clearTimeout(timer);
          if (!res.ok) throw res.status;
          setBusy(false);
          showSent(data);
        })
        .catch(function (status) {
          clearTimeout(timer);
          setBusy(false);
          showFormError(status === 429 ? labels.labelRate : labels.labelSendError);
        });
    });

    document.addEventListener('cdi:driven:change', function () {
      if (root.classList.contains('is-open')) renderSummary();
    });

    syncOther();
    syncIncludes();
    root.querySelectorAll('[data-cdi-driven-quote-seg]').forEach(syncSeg);
    return { open: open };
  }

  var quotePanel = document.querySelector('[data-cdi-driven-quote-panel]');
  var quote = quotePanel ? initQuote(quotePanel) : null;

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-cdi-driven-quote]');
    if (!trigger) return;
    if (quote && !cta.dataset.enquiryUrl) quote.open(trigger);
    else window.location.href = quoteUrl();
  });

  function initBar(bar) {
    if (bar.dataset.cdiInit) return;
    bar.dataset.cdiInit = 'true';
    var wrapper = bar.closest('.shopify-section') || bar;
    if (wrapper.parentElement !== document.body) document.body.appendChild(wrapper);

    var labels = bar.dataset;
    var totalEl = bar.querySelector('[data-cdi-driven-bar-total]');
    var grandEl = bar.querySelector('[data-cdi-driven-bar-grand]');
    var summaryEl = bar.querySelector('[data-cdi-driven-bar-summary]');
    var rowsEl = bar.querySelector('[data-cdi-driven-bar-rows]');
    var toggle = bar.querySelector('[data-cdi-driven-bar-toggle]');
    var scrim = wrapper.querySelector('[data-cdi-driven-bar-scrim]');

    function addRow(label, value, strong) {
      var row = document.createElement('div');
      row.className = 'cdi-driven-bar__row' + (strong ? ' is-strong' : '');
      var a = document.createElement('span');
      a.textContent = label;
      var b = document.createElement('span');
      b.textContent = value;
      row.appendChild(a);
      row.appendChild(b);
      rowsEl.appendChild(row);
    }

    function render() {
      var ids = Object.keys(state.selected);
      var sum = state.basePrice + addonTotal();
      totalEl.textContent = fmt(sum);
      grandEl.textContent = fmt(sum);
      var n = ids.length;
      summaryEl.textContent = n === 0 ? labels.labelNoAddons : n === 1 ? labels.labelOneAddon : tpl(labels.labelAddons, { count: n });
      rowsEl.textContent = '';
      addRow(state.productTitle + (state.variantTitle ? ' · ' + state.variantTitle : ''), fmt(state.basePrice), true);
      ids.forEach(function (id) {
        var item = state.selected[id];
        var qty = item.qty || 1;
        addRow(qty > 1 ? tpl(labels.labelQty, { title: item.title, qty: qty }) : item.title, fmt(item.price * qty));
      });
    }

    function setOpen(open) {
      bar.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.setAttribute('aria-label', open ? labels.labelHide : labels.labelShow);
      if (scrim) scrim.classList.toggle('is-visible', open);
    }

    function setVisible(visible) {
      if (visible) {
        bar.setAttribute('data-visible', '');
        bar.removeAttribute('aria-hidden');
        bar.inert = false;
      } else {
        bar.removeAttribute('data-visible');
        bar.setAttribute('aria-hidden', 'true');
        bar.inert = true;
        setOpen(false);
      }
    }

    toggle.addEventListener('click', function () {
      setOpen(!bar.classList.contains('is-open'));
    });

    document.addEventListener('cdi:driven:quote-open', function () {
      setOpen(false);
    });

    if (scrim) {
      scrim.addEventListener('click', function () {
        setOpen(false);
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && bar.classList.contains('is-open')) {
        setOpen(false);
        toggle.focus();
      }
    });

    document.addEventListener('cdi:driven:change', render);
    render();

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        setVisible(!entries[0].isIntersecting);
      }).observe(cta);
    } else {
      setVisible(true);
    }
  }

  document.querySelectorAll('[data-cdi-driven-addons]').forEach(initAddons);
  document.querySelectorAll('[data-cdi-driven-bar]').forEach(initBar);
})();
